import Env from 'src/environmentVariables/EnvironmentVariables';

/**
 * Appends the current Solana network (`env=devnet|mainnet-beta`) to a DB-backed
 * API URL so the server selects the matching network database. Devnet and
 * mainnet are physically separate databases — see src/db/index.ts.
 *
 * Use on every fetch to a route under src/app/api that reads or writes the DB.
 */
export function appendDbEnv(url: string): string {
	const separator = url.includes('?') ? '&' : '?';
	return `${url}${separator}env=${Env.sdkEnv}`;
}
